/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Keep keyboard focus out of off-screen Warehouse product carousel cards.
 * Flickity/Warehouse sets aria-hidden on individual product cards. Mirroring
 * that state with inert avoids focusable descendants in hidden accessibility
 * trees without changing visible product links, buttons or carousel geometry.
 */
(function () {
  'use strict';

  function attachProductCarouselAccessibility(scope) {
    var root = scope || document;
    var lists = root.querySelectorAll('.product-list--scrollable');
    if (root.matches && root.matches('.product-list--scrollable')) {
      lists = Array.prototype.slice.call(lists);
      lists.unshift(root);
    }

    Array.prototype.forEach.call(lists, function (list) {
      if (list.dataset.productCarouselAccessibilityReady === 'true') return;
      list.dataset.productCarouselAccessibilityReady = 'true';

      function syncCard(card) {
        if (!card.classList.contains('product-item')) return;
        card.inert = card.getAttribute('aria-hidden') === 'true';
      }

      Array.prototype.forEach.call(list.querySelectorAll('.product-item'), syncCard);

      if (!window.MutationObserver) return;
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes') {
            syncCard(mutation.target);
          } else if (mutation.type === 'childList') {
            Array.prototype.forEach.call(mutation.addedNodes, function (node) {
              if (node.nodeType !== 1) return;
              if (node.matches && node.matches('.product-item')) syncCard(node);
              if (node.querySelectorAll) {
                Array.prototype.forEach.call(node.querySelectorAll('.product-item'), syncCard);
              }
            });
          }
        });
      });

      observer.observe(list, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden'],
        childList: true
      });
    });
  }

  function init() {
    attachProductCarouselAccessibility(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attachProductCarouselAccessibility(event.target);
  });
})();
